import * as firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyAyvqooCqgsWKs95uyineKcY2rlpQF-peI',
  authDomain: 'dive-archivos-ficha.firebaseapp.com',
  databaseURL: 'https://dive-archivos-ficha.firebaseio.com',
  projectId: 'dive-archivos-ficha',
  storageBucket: 'dive-archivos-ficha.appspot.com',
  messagingSenderId: '246348754709',
};
firebase.initializeApp(config);

export const auth = firebase.auth().signInAnonymously();
export const storageRef = firebase.storage().ref();


// WEBPACK FOOTER //
// ./src/constants/firebase.js